module.exports = __webpack_public_path__ + "0ad7ee12fc655e82a0bfd263c622deb3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/train.png
// module id = 1950
// module chunks = 0